<template>
  <div>
    <v-text-field outlined label="Nyhetens namn" v-model="title"></v-text-field>
    <v-textarea outlined name="input-7-4" label="Pufftext" v-model="preamble"></v-textarea>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Banner-bild </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ImageComponent v-model="image" label="Banner-bild" @add-video="onAddVideo" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- Källor till nyheten -->
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Datum </v-expansion-panel-header>
        <v-expansion-panel-content>
          <DatePicker
            :date="orginalDate"
            label="Publiceringsdatum"
            @change="onChangeOriginalDate"
          />
          <!-- <DatePicker date="2022-04-01" label="Startdatum" @change="onChangeStartDate" />
          <DatePicker date="2022-04-01" label="Varaktighet" @change="onVaraktighet" /> -->
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- Datum -->
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Källor till nyheten </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- <div class="add-news-link">
            <a href="#" @click.prevent="showAddLink = !showAddLink">{{
              showAddLink ? 'Avbryt' : 'Lägg till källa'
            }}</a>
          </div> -->
          <EditNewsSource :newsId="newsId" :source="editSource" @close="editSource = null" />
          <AddNewsSource
            @add-link="addLink"
            :visible="newSourceDialog"
            @close="newSourceDialog = false"
          />
          <draggable v-model="links" handle=".drag-icon" ghost-class="ghost" @end="onSourceOrder">
            <NewsSource
              v-for="link in links"
              v-bind="link"
              :key="link.id"
              @delete="onDeleteSource"
              @edit="onEditSource"
              ><v-icon class="drag-icon">mdi-drag-vertical</v-icon></NewsSource
            >
          </draggable>
          <div class="button-add-source">
            <v-btn color="primary" text @click="newSourceDialog = true" :loading="loading"
              >Lägg till källa</v-btn
            >
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Nyckelord </v-expansion-panel-header>
        <v-expansion-panel-content>
          <Keywords v-model="keywords" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
/* eslint camelcase: 0 */
//https://cdn.azotelibrary.com/image/t400/skb_i450407b8.webp
import DatePicker from '../shared/DatePicker'
import NewsSource from '../news/NewsSource'
import AddNewsSource from '../news/AddNewsSource'
import EditNewsSource from '../news/EditNewsSource'
import Keywords from '../shared/Keywords'
import { format, parseISO } from 'date-fns'
import ImageComponent from '@/components/shared/Image'
import draggable from 'vuedraggable'

export default {
  name: 'TemplateNewsStandard',
  props: {
    loading: { type: Boolean, default: false },
    id: {
      type: [String, Number],
    },
    news_title: {
      type: String,
    },
    news_image_id: {
      type: [String, Number],
    },
    news_preamble: {
      type: String,
    },
    news_description: {
      type: String,
    },
    news_date_origin: {
      type: String,
    },
    news_date_added: {
      type: String,
    },
    newsLinks: {
      type: Array,
    },
    news_keywords: {
      type: String,
    },
  },
  components: {
    DatePicker,
    NewsSource,
    AddNewsSource,
    Keywords,
    ImageComponent,
    EditNewsSource,
    draggable,
  },
  data() {
    return {
      sources: [],
      newSourceDialog: false,
      editSource: null,
      links: [],
    }
  },

  watch: {
    newsLinks: {
      handler(links) {
        if (!links) {
          this.links = []
          return
        }
        this.links = [...links]
          .sort((a, b) => a.nl_order - b.nl_order)
          .map((nl) => ({
            ...nl.link,
            nl_id: nl.nl_id,
            ...nl,
          }))
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    newsId() {
      return +this.id
    },
    orginalDate: {
      get() {
        return format(parseISO(this.news_date_added), 'yyyy-MM-dd')
      },
      set(val) {
        this.$emit('update', { news_date_added: val })
      },
    },
    title: {
      get() {
        return this.news_title
      },
      set(val) {
        this.$emit('update', { news_title: val })
      },
    },
    preamble: {
      get() {
        return this.news_preamble
      },
      set(val) {
        this.$emit('update', { news_preamble: val })
      },
    },
    description: {
      get() {
        return this.news_description
      },
      set(val) {
        this.$emit('update', { news_description: val })
      },
    },
    image: {
      get() {
        return !Number.isNaN(this.news_image_id)
          ? `${process.env.VUE_APP_IMAGE_BACKEND}/870/${this.news_image_id}.jpg`
          : this.news_image_id
      },
      set(val) {
        this.$emit('update', { news_image_id: val.toString() })
      },
    },
    keywords: {
      get() {
        return this.news_keywords
      },
      set(val) {
        this.$emit('update', { news_keywords: val })
      },
    },
  },
  methods: {
    onSourceOrder() {
      const links = [...this.links].map((link, i) => ({ ...link, nl_order: i }))
      this.$emit('update-immediately', { newsLinks: links })
    },
    onEditSource(id) {
      this.editSource = this.links.find((l) => l.id === id)
    },

    onChangeOriginalDate(date) {
      this.orginalDate = date
    },
    addLink(link) {
      this.$emit('news:create:link', {
        ...link,
      })
    },
    onDeleteSource(url) {
      const links = [...this.links]
        .filter((l) => l.link.link_url !== url)
        .map((link, i) => ({ ...link, nl_order: i }))
      this.$emit('update-immediately', { newsLinks: links })
    },
    onAddVideo(value) {
      console.log(value, 'onAddVideo')
    },
  },
}
</script>

<style lang="less" scoped>
.add-news-link {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 7px;
}
.button-add-source {
  display: flex;
  justify-content: flex-end;
}
.ghost {
  opacity: 0.9;
  background: #cecece;
}
</style>
